import Icon from "../../../../../assets/spaceicons/bulk-import.svg";
import {
  SpaceComponentPackage,
  SpaceComponentHostType,
  SpaceComponentTags
} from "../../../../../types";
import { ElementLayout } from "../../../layout/util";
import { getSchema, errorSelector } from "../common/FunctionBackedPopover";
import reducer, {
  ensureSubmittableComponent,
  makeInitialState,
  SubmittableComponent,
  SubmittableComponentConfigState,
  SubmittableComponentProps
} from "../common/FunctionBackedPopover/reducer/reducer";

import Config from "./Config";
import SpaceFunctionBulkImport from "./SpaceFunctionBulkImport";

const pkg: SpaceComponentPackage<
  SubmittableComponentProps,
  SubmittableComponent,
  SubmittableComponentConfigState
> = {
  type: "FUNCTION_BULK_IMPORT",
  displayName: "Bulk Action",
  Icon,
  allowedHosts: new Set<SpaceComponentHostType>([
    "HEADER",
    "TABLE",
    "DETAIL",
    "CARD_LIST",
    "FLEX_BOX"
  ]),
  Component: SpaceFunctionBulkImport,
  ConfigurationComponent: Config,
  componentConfigReducer: reducer,
  ensureComponent: ensureSubmittableComponent,
  getInitialDraftState: makeInitialState,
  getSchema,
  defaultElementLayout: new ElementLayout({
    width: "auto",
    height: "auto",
    snapToGrid: false
  }),
  fallbackWidth: 77,
  allowSelfBinding: false,
  allowAncestorBinding: true,
  tags: [SpaceComponentTags.Base],
  isHeadless: false,
  errorSelector,
  isContainer: false
};

export default pkg;
